import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FilterDramaIcon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_drama"}/>
}
